import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BidIncrementButton,
  BidIncrementButtonsContainer, BidIncrementsContainer,
  ButtonGrid, HotKeyLabel, TabButtonContainer, TabButton,
} from './Styles';
import { useStores } from '../../../../hooks';

const BidIncrementContainer = () => {
  const {
    AuctionStore: {
      connected,
      auctionLaneId,
      settings,

    },
    BidStore: {
      auction,
      lanePaused,
      laneSuspended,
    },
    UIStore: {
      handleBidIncrementClick,
      getHotKey,
    },
  } = useStores();

  const { bidIncrementList } = settings;

  return (
    <BidIncrementsContainer>
      <TabButtonContainer>
        <TabButton
          disabled
          width="50%"
          borderTop
          borderRight
          borderBottom
          borderLeft
        >
          Default ($
          {auction.defaultBidIncrement}
          )
        </TabButton>
        <TabButton selected width="50%" borderTop borderRight>
          Current
        </TabButton>
      </TabButtonContainer>
      <BidIncrementButtonsContainer show id="current-bid-increment">
        <ButtonGrid>
          {bidIncrementList.map((value) => (
            <BidIncrementButton
              data-testid={`bid-inc-${value}`}
              selected={auction.standardBidIncrement === value}
              disabled={
                      auction.standardBidIncrement === value
                      || !connected
                      || lanePaused
                      || laneSuspended
                    }
              connected={
                      connected && auctionLaneId && !lanePaused && !laneSuspended
                    }
              key={value}
              onClick={() => handleBidIncrementClick(value)}
            >
              $
              {new Intl.NumberFormat().format(value)}
              <HotKeyLabel
                color={
                        auction.standardBidIncrement === value ? 'black' : 'white'
                      }
              >
                {getHotKey('target', value)
                    && getHotKey('target', value).label}
              </HotKeyLabel>
            </BidIncrementButton>
          ))}
        </ButtonGrid>
      </BidIncrementButtonsContainer>
    </BidIncrementsContainer>
  );
};

export default observer(BidIncrementContainer);
